// Module
var code = "<div id=\"V-3379477F-2466-4C3A-AA83-80BC25893CAB\"> <div data-b-component=\"input\" class=\"input\" data-b-comp-text=\"{Binding value}\"></div> </div> ";
// Exports
export default code;